import { Panel } from "shared/components/panel/Panel";
import BodyPanel from "shared/components/panel/BodyPanel";
import HeaderPanel from "shared/components/panel/HeaderPanel";
import CadastrarContaDigitalPartner from "./CadastrarContaDigitalPartner";

const ContaDigital: React.FC = () => {
  return (
    <Panel headerPanel={<HeaderPanel title="Contas" abaAtual="Conta Digital" />}>
      <BodyPanel noPadding>
        <CadastrarContaDigitalPartner />
      </BodyPanel>
    </Panel>
  );
};

export default ContaDigital;
